


































































import { defineComponent, toRefs, PropType, ref, computed, watch } from '@vue/composition-api';
import Vue from 'vue';
import {
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  FormItem,
  FullNormalFormData,
  Interactive_Addon_CardType,
  NormalCreative,
} from '@tt4b/ttam-enums';
import InteractiveAddOn from './index';
import { imgSrcPrefix, getImgSrcByEnv, getPosterUrlFromCreativeForm } from '@tt4b/ttam-utils';
import { trackEvent } from './../../../utils/index';
import { useCreativeActionTypeIs, useSplitTestEnabled } from '@tt4b/ttam-hooks';
import TtamInteractiveAddOnTileWarning from './tile-warning/index.vue';

const name = 'ttam-interactive-add-on-compose';
export default defineComponent({
  name,
  components: {
    TtamInteractiveAddOnEditor: InteractiveAddOn.TtamInteractiveAddOnEditor,
    TtamInteractiveAddOnEditorDrawer: InteractiveAddOn.TtamInteractiveAddOnEditorDrawer,
    TtamInteractiveAddOnLibraryDrawer: InteractiveAddOn.TtamInteractiveAddOnLibraryDrawer,
    TtamInteractiveAddOnErrorTip: InteractiveAddOn.TtamInteractiveAddOnErrorTip,
    TtamInteractiveAddOnPreviewThumbnail: InteractiveAddOn.TtamInteractiveAddOnPreviewThumbnail,
    TtamInteractiveAddOnDrawer: InteractiveAddOn.TtamInteractiveAddOnDrawer,
    TtamInteractiveAddOnTileWarning,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    normalCreative: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: 'create',
    },
    drawerMarginTop: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData, normalCreative, createMode } = toRefs(props);
    const form = ref<FormItem>();
    const drawerVisible = ref(false);
    const drawerUrl = ref('');
    const isCreateNewAddon = ref(false);
    const videoUrl = computed(() => {
      if (creativeData.value.cardInfo?.cardType === Interactive_Addon_CardType.ImageCard) {
        return '';
      }
      return getPosterUrlFromCreativeForm(creativeData.value);
    });
    const isLoading = computed(() => creativeData.value.cardInfo?.loading);
    const { visible: errorTipVisible } = InteractiveAddOn.usePropsErrorTipVisible({
      creativeData,
    });

    const { visible: tileWarningVisible } = InteractiveAddOn.usePropsTileWarningVisible({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      creativeFormData: creativeData,
      createMode,
    });

    const { disabled } = InteractiveAddOn.usePropsEditorDisabled({
      campaignData,
      adgroupData,
      creativeData,
      normalCreative,
      createMode,
    });
    const { isShowAddonPreviewThumbnail, isAddonDeleteBtnDisabled, isAddonEditBtnHide } =
      InteractiveAddOn.usePropsAddonBtnVisible({
        campaignData,
        adgroupData,
        creativeData,
        normalCreative,
        createMode,
      });

    const { isCreate, isEdit } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    const { isSplitTestLevelEnabled } = useSplitTestEnabled({ campaignData, adgroupData });
    const drawerTop = computed(() =>
      isCreate.value || isSplitTestLevelEnabled.value
        ? props.drawerMarginTop ?? Vue.prototype.$TTAMUI?.headerHeight
        : '0px',
    );
    const { events } = InteractiveAddOn.usePropsDrawerEvents();
    const { initData } = InteractiveAddOn.usePropsInitData({
      campaignData,
      adgroupData,
      creativeData,
      normalCreative,
      createMode,
      isCreateNewAddon,
    });
    const _cardId = computed({
      get() {
        return creativeData.value.cardId;
      },
      set(val) {
        emit('change', {
          cardId: val,
        });
      },
    });

    const _cardInfo = computed({
      get() {
        return creativeData.value.cardInfo || {};
      },
      set(val) {
        emit('change', {
          cardInfo: val,
        });
      },
    });
    const handleDeleteAddon = () => {
      _cardId.value = '';
      _cardInfo.value = {
        isDeleteCard: true,
      };
    };
    const openEditorDrawer = () => {
      const { url } = InteractiveAddOn.usePropsDrawerUrl();
      drawerUrl.value = url;
      drawerVisible.value = true;
      isCreateNewAddon.value = false;
    };
    const openNewEditorDrawer = () => {
      const { url } = InteractiveAddOn.usePropsDrawerUrl();
      drawerUrl.value = url;
      drawerVisible.value = true;
      isCreateNewAddon.value = true;
    };

    const openLibraryDrawer = () => {
      const { url } = InteractiveAddOn.usePropsDrawerUrl('library');
      drawerUrl.value = url;
      drawerVisible.value = true;
    };
    const onUpdate = (data: { attachment_creative_id: string; portfolio_type: number; thumbnail_uri: string }) => {
      const { attachment_creative_id, portfolio_type, thumbnail_uri } = data;
      _cardId.value = attachment_creative_id;
      _cardInfo.value = {
        thumbnailUrl: `${getImgSrcByEnv({ URL: imgSrcPrefix.URL }, thumbnail_uri)}?time=${Date.now()}`,
        cardType: portfolio_type,
      };
    };

    const onRetry = () => {
      trackEvent('module_ad_creative_card_fail_retry');
      emit('retry');
    };

    watch(_cardId, () => {
      form.value?.validate?.('');
    });

    return {
      name,
      form,
      isLoading,
      errorTipVisible,
      tileWarningVisible,
      _cardInfo,
      videoUrl,
      disabled,
      isShowAddonPreviewThumbnail,
      isAddonDeleteBtnDisabled,
      isAddonEditBtnHide,
      isEdit,
      drawerUrl,
      events,
      initData,
      drawerTop,
      drawerVisible,
      openEditorDrawer,
      openLibraryDrawer,
      openNewEditorDrawer,
      onRetry,
      onUpdate,
      handleDeleteAddon,
    };
  },
});
